var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"group-view"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-card',[_c('v-card-title',[_vm._v(" Grupo "+_vm._s(_vm.groupData.name)+" ")]),_c('group-panel',{attrs:{"group-data":_vm.groupData},on:{"already-save":_vm.onAlreadySave}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }